import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { CharterDAO } from '../../../../../../../core/services/dao/charterDAO';
import { getUtcCharterDate } from '../../../../../../../core/models/charter';
import { Charter } from 'anchor-shared/lib/model/entity/charter';

import * as moment from 'moment';
import { ConstantMan } from '../../../../../../../core/services/constantMan';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { NumberFormatterService } from '../../../../../../../core/services/number.formatter.service';
import { ContainsSubscriptions } from '../../../../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../../../../core/pure-functions/rx-helper';
import { Subscription } from 'rxjs';
import { EnvironmentalMediaService } from '../../../../../../../core/services/environmental-media.service';

@Component({
  selector: 'app-history-form',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class HistoryFormComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];

  @Input() model: any;

  public columnDefs;
  public rowData: Charter[];
  public charters: Charter[];

  constructor(
    private numFormatter: NumberFormatterService,
    private environmentalMediaService: EnvironmentalMediaService,
  ) {}

  ngOnInit() {
    this.charters = this.model;
    this.rowData = this.formatDates(this.charters);
    this.columnDefs = this.createColumnDefs();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  private formatDates(charters: Charter[]): Charter[] {
    const _charters = [];
    charters.forEach((charter) => {
      _charters.push({
        id: charter.id,
        date: getUtcCharterDate(charter).format('MM-DD-YY'),
        boatName: charter.boatName,
        boatOwnerPay: this.getBoatOwnerPay(charter),
        captainChecklistUrl: charter.captainManageDetails
          ? `${this.environmentalMediaService.getClientBaseURL()}/manage/captain-checklist/${
              charter.id
            }`
          : null,
      });
    });
    return _charters;
  }

  private getBoatOwnerPay(charter: Charter): string {
    let ownerPay = null;
    const ownerPayout = this.getOwnerPayout(charter);
    if (ownerPayout !== null) {
      if (ownerPayout.published) {
        ownerPay = this.numFormatter.formatStringAsCurrency(
          ownerPayout.actualPay,
        );
      } else {
        ownerPay = 'Processing';
      }
    }
    return ownerPay;
  }

  private getOwnerPayout(charter: Charter): Payout {
    let ownerPayout = null;
    if (charter.payouts) {
      charter.payouts.forEach((value) => {
        if (value.type === ConstantMan.PAYOUT_TYPES.OWNER) {
          ownerPayout = value;
        }
      });
    }
    return ownerPayout;
  }

  private createColumnDefs(): any {
    return [
      {
        headerName: 'Charter Id',
        field: 'id',
        filter: 'text',
        minWidth: 50,
      },
      {
        headerName: 'Charter Date',
        field: 'date',
        filter: 'text',
      },
      {
        headerName: 'Boat Name',
        field: 'boatName',
        filter: 'text',
      },
      {
        headerName: 'Boat Owner Pay',
        field: 'boatOwnerPay',
        filter: 'text',
      },
      {
        headerName: 'Captain Checklist',
        field: 'captainChecklistUrl',
        filter: false,
        cellRenderer: (params: any) => {
          if (!params.value) {
            return '';
          }
          return `
            <a
              type="button"
              class="link-button"
              onclick="window.open('${params.value}', '_blank')"
            >
              View Checklist
            </a>
          `;
        },
      },
    ];
  }
}
